// @flow

import React from 'react';
import type { Node } from 'react';
import { Flex } from '../../../grid';
import { LabelText } from './labeledCheckbox.styled';
import Label from '../../label';

type Props = {
  label: string,
  children: Node,
};

const LabeledCheckBox = ({
  label,
  children,
}: Props) => (
  <Flex mb="1.5em">
    <Label alignItems="flex-start">
      {children}
      <LabelText dangerouslySetInnerHTML={{ __html: label }} />
    </Label>
  </Flex>
);

export default LabeledCheckBox;
